import { reject } from 'lodash';
import * as publicTypes from './publicTypes';



//POST CLINIC PROFILE 
export const postClinicProfileRequest = (data, resolve, reject) => ({
  type: publicTypes.POST_CLINICPROFILE_REQUEST,
  payload: { data, resolve, reject }
})
export const postClinicProfileSuccess = (data) => ({
  type: publicTypes.POST_CLINICPROFILE_SUCCESS,
  payload: { data }
})
export const postClinicProfileFailure = (error) => ({
  type: publicTypes.POST_CLINICPROFILE_FAILURE,
  payload: { error }
})

export const getClinicProfileByIdRequest = (clinicId, resolve, reject) => ({
  type: publicTypes.GET_CLINICPROFILE_BY_ID_REQUEST,
  payload: { clinicId, resolve, reject }
})
export const getClinicProfileByIdSuccess = (data) => ({
  type: publicTypes.GET_CLINICPROFILE_BY_ID_SUCCESS,
  payload: { data }
})
export const getClinicProfileByIdFailure = (error) => ({
  type: publicTypes.GET_CLINICPROFILE_BY_ID_FAILURE,
  payload: { error }
})


//POST DOCTOR PROFILE 
export const postDoctorProfileRequest = (data, resolve, reject) => ({
  type: publicTypes.POST_DOCTORPROFILE_REQUEST,
  payload: { data, resolve, reject }
})
export const postDoctorProfileSuccess = (data) => ({
  type: publicTypes.POST_DOCTORPROFILE_SUCCESS,
  payload: { data }
})
export const postDoctorProfileFailure = (error) => ({
  type: publicTypes.POST_DOCTORPROFILE_FAILURE,
  payload: { error }
})
//GET DOCTOR PROFILE BY ID
export const getDoctorProfileByIdRequest = (doctId, resolve, reject) => ({
  type: publicTypes.GET_DOCTORPROFILE_BY_ID_REQUEST,
  payload: { doctId, resolve, reject }
})
export const getDoctorProfileByIdSuccess = (data) => ({
  type: publicTypes.GET_DOCTORPROFILE_BY_ID_SUCCESS,
  payload: { data }
})
export const getDoctorProfileByIdFailure = (error) => ({
  type: publicTypes.GET_DOCTORPROFILE_BY_ID_FAILURE,
  payload: { error }
})


//login
export const login = (data, resolve, reject) => ({
  type: publicTypes.LOGIN,
  data,
  resolve,
  reject,
});
export const restoreSession = () => ({ type: publicTypes.RESTORE_SESSION });

//GET CLINIC
export const getClinicRequest = (token, resolve, reject) => ({
  type: publicTypes.GET_CLINIC_REQUEST,
  payload: { token, resolve, reject }
})
export const getClinicSuccess = (data) => ({
  type: publicTypes.GET_CLINIC_SUCCESS,
  payload: { data }
})
export const getClinicFailure = (error) => ({
  type: publicTypes.GET_CLINIC_FAILURE,
  payload: { error }
})

//POST CUSTOM PATIENT FIELDS
export const postCustomPatientFieldsRequest = (data, resolve, reject) => ({
  type: publicTypes.POST_CUSTOM_PATIENT_FIELDS_REQUEST,
  payload: { data, resolve, reject }
})
export const postCustomPatientFieldsSuccess = (data) => ({
  type: publicTypes.POST_CUSTOM_PATIENT_FIELDS_SUCCESS,
  payload: { data }
})
export const postCustomPatientFieldsFailure = (error) => ({
  type: publicTypes.POST_CUSTOM_PATIENT_FIELDS_FAILURE,
  payload: { error }
})







